<template>
    <div class="ex_live_pro"  :class="{is_show:isShow&&dataVal}" @click="LinkProduct(dataVal.ProductId)">
      <img v-if="dataVal.Banner" :src="dataVal.Banner" >
      <img v-else src="@/assets/img/empty.png" >
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "ex-live-pro",
  data() {
    return {
      isShow: false,
      dataVal: {},
      timer: null,
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
    })
  },
  created(){
  },
  mounted(){
  },
  beforeDestroy(){
    this.timer=null;
  },
  methods: {
    ...mapActions({
      LinkProduct:'linkTo/LinkProduct'
    }),
    showOpen(data) {
      let sp=0;
      if(this.isShow){
        sp=300;
      }
      this.isShow = false;
      this.dataVal=data;
      if(this.timer){
        clearTimeout(this.timer);
        this.timer=null;  
        sp=300;
      }
      setTimeout(() => {
        this.isShow=true;
        if(this.dataVal.Second>0){
          this.timer = setTimeout(() => {
            this.isShow = false;
            this.dataVal={};
          }, this.dataVal.Second*1000);
        }
      }, (sp));
    },
    showClose(data){
      console.log(data,'取消推屏');
      this.isShow = false;
      this.dataVal={};
      if(this.timer){
        clearTimeout(this.timer);
        this.timer=null;  
      }
    }
  },
};
</script>

<style scoped lang="scss">
.ex_live_pro{
  position: absolute;
  top: 60px;
  z-index: 3000;
  left: -1.6rem;
  // background: #000;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 0.05rem;
  overflow: hidden;
  &.is_show{
    transition:left .3s;
    left: 0.3rem;
  }
  img{
    width: 100%;
    height: 100%;
    // object-fit: cover;
  }
}
</style>
